export default "__VITE_ASSET__6lp6q1zR__"